<template>
  <v-toolbar-title
    class="flex-grow-1 text-subtitle-1 font-weight-bold"
    style="min-width: 0; white-space: normal; line-height: 1.2"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      style="
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      "
    >
      <slot>{{ text }}</slot>
    </div>
  </v-toolbar-title>
</template>

<script>
export default {
  name: "ResponsiveToolbarTitle",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
